import Vue from 'vue'

Vue.filter('formatPrice', (value) => {
  const formatter = new Intl.NumberFormat()
  return formatter.format(value)
})
